import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { getInteractiveVizNavFromIrisDataState } from '../selectors/interactiveVizNav';
import getProgramName, {
    getInteractiveVizNavFromSession,
} from '../helpers/Utils/interactiveVizNav';

export const getFitFinderDigitalData = (store) => {
    const state = store.getState();
    const interactiveVizNav = getInteractiveVizNavFromIrisDataState(state);
    let digitalData = {};
    /* istanbul ignore next */
    if (!_isEmpty(interactiveVizNav)) {
        const programId = _get(interactiveVizNav, 'programId', '');
        const {
            isModalOpenedForSession,
            navigationIndex: sessionNavigationIndex,
        } = getInteractiveVizNavFromSession(programId);
        const navigations = _get(interactiveVizNav, 'navigations', [{}]);
        const defaultNavigationIndex = _get(interactiveVizNav, 'defaultNavigationIndex', 0);
        const navigationIndex = sessionNavigationIndex || defaultNavigationIndex;
        const navItems = _get(navigations[navigationIndex], 'navLinks', []);
        const fitFinderPersona = _get(navigations[navigationIndex], 'navItem', '');

        const fitFinderProgramName = getProgramName(navItems);
        digitalData = {
            page: {
                attributes: {
                    fitFinderComponent: 'yes',
                },
            },
        };

        if (!isModalOpenedForSession) {
            digitalData.page.attributes.fitFinderModal = 'yes';
        }

        if (fitFinderProgramName) {
            digitalData.page.attributes.fitFinderProgramName = fitFinderProgramName;
        }

        if (fitFinderPersona) {
            digitalData.page.attributes.fitFinderPersona = fitFinderPersona;
        }
    }

    return digitalData;
};

export default getFitFinderDigitalData;
